module.exports = __webpack_public_path__ + "img/3ec2665.png";